{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "ใช้งาน",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "LAST_7_DAYS": "7 วันที่ผ่านมา",
      "LAST_30_DAYS": "30 วันที่ผ่านมา",
      "LAST_3_MONTHS": "3 เดือนที่ผ่านมา",
      "LAST_6_MONTHS": "6 เดือนที่ผ่านมา",
      "LAST_YEAR": "ปีที่ผ่านมา",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "กำหนดช่วงระยะเวลา"
    }
  }
}
